<button mat-icon-button color="primary" title="Return to the previous screen" (click)="back()">
    <mat-icon>keyboard_backspace</mat-icon> Back
</button>
<div class="header">
    <section-title text="Pending Payment Request"></section-title>
</div>
<mat-card>
    <mat-card-content>
        <div class="details">
            <div>
                <span class="text">Payment Request ID:</span>
                <span class="data">{{pendingPaymentRequest?.paymentRequestId}}</span>
                <button mat-icon-button size="small" *ngIf="pendingPaymentRequest?.paymentRequestId" title="Copy payment request reference number to clipboard" [cdkCopyToClipboard]="pendingPaymentRequest.paymentRequestId" (click)="showSuccess('Copied to clipboard')">
                    <mat-icon>file_copy</mat-icon>
                </button>
            </div>
            <div><span class="text">Payment Date:</span><span class="data">{{pendingPaymentRequest?.createDate | localTime}}</span></div>
            <div><span class="text">Requested Amount:</span><span class="data">{{pendingPaymentRequest?.requestedUnit}} {{pendingPaymentRequest?.requestedAmount | number: '1.0-2'}}</span></div>
            <div><span class="text">Requested Payment Amount:</span><span class="data">{{pendingPaymentRequest?.requestedPaymentUnit}} {{pendingPaymentRequest?.receivedPaymentAmount}}</span></div>
            <div><span class="text">Received Payment Amount:</span><span class="data">{{pendingPaymentRequest?.receivedPaymentUnit}} {{pendingPaymentRequest?.receivedPaymentAmount}}</span></div>
            <div>
                <span class="text"></span>
                <span class="amount">
                    <mat-form-field appearance="fill">
                        <mat-label>Amount After Fee</mat-label>
                        <input type="number" matInput [formControl]="amountFormControl" placeholder="Amount After Fee" [(ngModel)]="pendingPaymentRequest.netAmount" min="0" step="1" name="amount">
                        <mat-error *ngIf="amountFormControl.hasError('required')">Amount is <strong>required</strong></mat-error>
                        <mat-error *ngIf="amountFormControl.hasError('min')">Amount must be greater <strong>zero</strong></mat-error>
                    </mat-form-field>
                </span>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button color="primary" [disabled]="!formValid()" (click)="approve()">Approve</button>
        <button mat-stroked-button (click)="cancel()">Cancel</button>
    </mat-card-actions>
</mat-card>